import { get } from "lodash";

export default state => get(state, "receivables.outstandingTotals");
